import SmoothScroll from "smooth-scroll"
import pose from "popmotion-pose"

import { Ias } from "./ias"
import { qq, q } from "../../helper/q"

const scroll = new SmoothScroll('.up a[href*="#"]', {
  updateURL: false
})

let ias

export const route = () => {
  const linkElements = Array.from(document.querySelectorAll(".referenceMenuLink"))
  const iasElement = document.querySelector(".referenceContainerLoad")
  if (iasElement) {
    ias = new Ias(iasElement)
    iasElement && ias.init()
  }

  linkElements.map((link, index) => {
    link.addEventListener("click", e => {
      e.preventDefault()
      removeActive(linkElements)
      link.classList.add("referenceMenuLinkActive")
      fetchingPage(link.href)
    })
  })
}

const elementsProps = {
  initialPose: "open",
  open: {
    opacity: 1,
    beforeChildren: true,
    staggerChildren: 150
  },
  closed: {
    opacity: 0,
    delay: 300,
    afterChildren: false,
    staggerChildren: 50
  }
}

const elementProps = {
  initialPose: "closed",
  open: {
    opacity: 1,
    y: 0
  },
  closed: {
    opacity: 0,
    y: 50
  }
}

// Загружаем страницу и рендерем ее в контейнер, подменяю url в адресной строке
const fetchingPage = url => {
  const loadElements = document.querySelector(".referenceContainerLoad")
  const loadElement = qq(".referenceSection")

  scroll.animateScroll(document.querySelector("#referencePopup"), null, {
    offset: 250
  })

  const itemPoser = pose(loadElements, elementsProps)
  loadElement.forEach((item, i) =>
    itemPoser.addChild(item, {
      ...elementProps
    })
  )

  itemPoser.set("closed").then(() => {
    loadElements.classList.add("referenceContainerLoadHidden")
    q(".referenceContainerLoader").classList.add("referenceContainerLoaderVisable")
    history.pushState(null, null, url)
    fetchPage(url).then(res => {
      loadElements.innerHTML = res
      itemPoser.clearChildren()
      qq(".referenceSection", loadElements).forEach((item, i) => {
        item.style.opacity = 0
        itemPoser.addChild(item, {
          ...elementProps
        })
      })
      q(".referenceContainerLoader").classList.remove("referenceContainerLoaderVisable")
      loadElements.classList.remove("referenceContainerLoadHidden")

      itemPoser.set("open")
      ias.reinit()
    })
  })
}

// удаляем активные элементы с nav
const removeActive = elements => {
  elements.map(element => {
    element.classList.remove("referenceMenuLinkActive")
  })
}

// helper fetch
const fetchPage = url => {
  const options = {
    method: "GET",
    credentials: "include"
  }
  return fetch(url + "?ajax=yes", options).then(res => res.text())
}
